export const projects = [
  {
    title: 'Auto Prime Dealership Management System',
    category: ['Full Stack', 'AI & Automation'],
    description: 'Full dealership operating platform built after face-to-face research with local dealership owners. Covers public vehicle website, secure admin console, inventory, CRM, deals, payments, finance, trade-ins, commissions, expenses, employees, reports, backups, audit logs, MFA, and role-based permissions. Integrated a Python FastAPI + Google ADK/Gemini AI assistant for dealership queries.',
    technologies: ['Next.js', 'TypeScript', 'Node.js', 'Express', 'Python', 'FastAPI', 'Supabase', 'PostgreSQL', 'Google Gemini', 'Tailwind CSS'],
    image: 'https://images.unsplash.com/photo-1695395782827-c1f017d721cd?auto=format&fit=crop&q=80&w=800',
    website: 'TODO_AUTO_PRIME_LIVE_URL',
    github: 'TODO_AUTO_PRIME_GITHUB_URL',
  },
  {
    title: 'TradeTrack Multi-Tenant Contractor SaaS',
    category: ['Full Stack', 'AI & Automation'],
    description: 'Multi-tenant SaaS for solo contractors and service businesses. Full workflow from client to quote to job to invoice to payment. Tenant architecture with org-scoped queries, RBAC, signed storage URLs, rate limiting, server-side PDF generation, and a Python FastAPI invoice worker. Includes Vitest coverage for core business workflows.',
    technologies: ['Next.js 14', 'TypeScript', 'Prisma', 'PostgreSQL', 'Supabase', 'NextAuth.js', 'Tailwind CSS', 'Docker', 'Vitest', 'Python'],
    image: 'https://images.unsplash.com/photo-1773427457869-6fbded8b89b9?auto=format&fit=crop&q=80&w=800',
    website: 'TODO_TRADETRACK_LIVE_URL',
    github: 'TODO_TRADETRACK_GITHUB_URL',
  },
  {
    title: 'MAMMOCARE AI Mammogram Guidance Platform',
    category: ['Full Stack', 'AI & Automation'],
    description: 'University team project for AI-assisted mammogram screening. Role-based patient, doctor, and admin portals via Firebase Auth. Python FastAPI AI proxy integrates Roboflow detection, returning bounding boxes and confidence values. Features annotated canvas rendering, PDF report generation, doctor booking, and realtime chat with file attachments.',
    technologies: ['HTML', 'CSS', 'JavaScript', 'Firebase', 'Python', 'FastAPI', 'Roboflow API', 'Canvas API', 'jsPDF'],
    image: 'https://images.unsplash.com/photo-1769698678497-c41f0ab47c3e?auto=format&fit=crop&q=80&w=800',
    github: 'TODO_MAMMOCARE_GITHUB_URL',
  },
  {
    title: 'Elite Beauty Salon',
    category: 'Web App',
    description: 'A conversion-focused business website built for a beauty salon to streamline customer inquiries and appointment bookings. Developed using React and Tailwind CSS, with WhatsApp click-to-chat integration to enable direct customer communication and increase lead conversions.',
    technologies: ['React', 'Vite', 'Tailwind CSS', 'WhatsApp API'],
    image: 'https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?auto=format&fit=crop&q=80&w=800',
    website: 'https://deckproprojectsalon.netlify.app/',
  },
  {
    title: 'Precision Construction Services',
    category: 'Web App',
    description: 'A fully responsive frontend website for a construction services company, focusing on project showcases and mobile performance. Built with React, Vite, Tailwind CSS, and Framer Motion.',
    technologies: ['React', 'Vite', 'Framer Motion', 'Tailwind CSS'],
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&q=80&w=800',
    website: 'https://deckproconstruction.netlify.app/',
  },
  {
    title: 'Chanuka Dev Portfolio',
    category: 'Full Stack',
    description: 'A personal freelance brand platform showcasing production-ready projects and providing a central hub for client inquiries. Built with React and supported by a Node.js and Express backend.',
    technologies: ['React', 'Node.js', 'Express', 'MongoDB'],
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800',
    website: 'https://deckpro.space',
  },
  {
    title: 'Tuition Management Android App',
    category: 'Mobile App',
    description: 'Android application to manage students, classes, attendance, and assignments for tuition centers. QR-based attendance tracking and cloud-based assignment submissions via Firebase.',
    technologies: ['Android Studio', 'Kotlin', 'Firebase', 'QR Code Scanning'],
    image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&q=80&w=800',
    github: 'https://github.com/itschanuka',
  },
  {
    title: 'Urban Food E-Commerce',
    category: 'Web App',
    description: 'University Database Management project. Full-stack food platform with cart, wishlist, checkout, order history, and admin workflows. Oracle Database for transactional data, MongoDB for reviews. Admin reporting with PL/SQL procedures, CSV/XML exports, and PDF generation.',
    technologies: ['PHP', 'Oracle Database', 'PL/SQL', 'MongoDB', 'HTML', 'CSS', 'JavaScript'],
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&q=80&w=800',
    github: 'https://github.com/itschanuka',
  },
  {
    title: 'Smart Parcel Box',
    category: 'IoT Project',
    description: 'IoT-based smart parcel box with ESP8266, sensors, and servo motors integrated with Firebase for real-time monitoring and automated access control.',
    technologies: ['ESP8266', 'Firebase', 'Sensors', 'Servo Motor'],
    image: 'https://images.unsplash.com/photo-1580674684081-7617fbf3d745?auto=format&fit=crop&q=80&w=800',
    github: 'https://github.com/itschanuka',
  },
  {
    title: 'Autonomous Luggage Robot',
    category: 'IoT Project',
    description: 'Automated robotics project using line-following, obstacle detection, and RFID-based navigation via Arduino Mega, ultrasonic sensors, and RFID modules.',
    technologies: ['Arduino Mega', 'RFID', 'Ultrasonic Sensors'],
    image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&q=80&w=800',
    github: 'https://github.com/itschanuka',
  },
];
